const einDashboard = {
  einDashboard: {
    installingSince: 'Instalando Enphase desde',
    accountManager: 'Gerente de cuenta',
    installationShare: 'Porción de las instalaciones de Enphase',
    nps: 'Índice Neto de Promotores',
    viewDashboard: 'Visualizar Panel',
    quarterInfo: 'desde Q%{quarter},%{year} (Residencial)',
    npsTooltip: `El Índice de lealtad del cliente (NPS) es un índice que va de -100 a 100 que mide la disposición de los clientes a recomendar los productos o servicios de una empresa a otros. Esta puntuación se basa en las calificaciones otorgadas por sus clientes en la aplicación móvil Enlighten para sus servicios y solo es visible para usted y Enphase. El período de tiempo predeterminado para los datos es los últimos 13 meses.`,
    activity: 'Actividad',
    sites: 'Sitios',
    batteries: 'Baterías',
    acb: 'ACB',
    certifications: 'Certificaciones',
    community: 'Comunidad',
    storage: 'Sitios de almacenamiento',
    lastInstalledLabel: 'instalado en los últimos 12 meses',
    lastCommissionedLabel: 'encargadas en los últimos 12 meses',
    viewDetails: 'Visualizar detalles',
    seeReviews: 'Ver reseñas',
    viewCommunity: 'Visualizar comunidad',
    certificateLabel: '%{count} de %{totalCount} Certificaciones completadas',
    networkLabel: {
      one: '%{count} publicación, última publicación: %{postDate}',
      other: '%{count} publicaciones, última publicación: %{postDate}'
    },
    requestProductAccess: 'Solicitar acceso de productos',
    inverter: 'IQ-8',
    ensemble: 'Ensemble 2.0',
    permit: 'Asistencia para permisos',
    sgip: 'Asistencia para SGIP',
    learnMore: 'Más información',
    aboutProduct: 'acerca del producto',
    betaReleaseDate: 'Fecha de lanzamiento beta',
    requestEarlyAccess: 'Solicitar acceso temprano',
    viewAllProduct: 'Visualizar todos los productos',
    signUp: 'Registrarme',
    betaReleaseLabel: 'para todos los nuevos lanzamientos de productos beta',
    financing: 'Soporte financiero',
    digitalPlatform: 'Plataforma digital',
    lpp: 'LPP',
    requestedText: 'Solicitud enviada para acceso temprano',
    grantedText: 'Acceso beta otorgado',
    products: 'Productos',
    ratingsReviews: 'Clasificaciones y reseñas',
    reviews: 'Reseñas',
    otherReviews: 'Otras reseñas',
    updateDetails: 'Actualizar los detalles',
    totalSavings: 'Ahorros totales',
    inLastYear: 'En los últimos 12 meses',
    viewBreakdown: 'Visualizar desglose',
    leadsReceived: 'Clientes potenciales recibidos',
    leadsClosure: 'Cierre de clientes potenciales',
    leadsWon: 'Clientes potenciales ganados',
    creditAvailable: 'Crédito disponible',
    buyMore: 'Comprar más',
    messageFromCeo: 'Mensaje de nuestro Director General',
    communityUpdates: 'Actualizaciones de la comunidad',
    makeAppointments: 'Agendar citas',
    applicableText: 'Aplicable exclusivamente para miembros platino',
    view: 'Ver',
    downloadAll: 'Descargar todo',
    promoteText: 'Promueve tu compañía con credenciales y logotipos',
    asOfText: 'Desde: %{date}',
    yearTotal: 'Total/año',
    redeemed: 'Canjeado',
    laborProtectionPlan: 'Programa de protección laboral',
    acmPromotion: 'Promoción de ACM',
    save: {
      lre_data: 'Ahorros de LPP',
      permit_data: 'Ahorros de Permisos',
      financing_data: 'Ahorros de Financiamiento',
      sgip_data: 'Ahorros de SGIP',
      warrantyExtension: 'Ahorros de extensión de garantía'
    },
    platinumLogo: 'Logotipo de Platinum',
    enphaseLogo: 'Logotipo de Enphase ',
    otherAssets: 'Otros activos',
    ensembleCertificate: 'Ensemble 1.0 Certificado',
    salesCertificate: 'Sales 1.0 Certificado',
    marketingCertificate: 'Marketing 1.0 Certificado',
    solarInstallCertificate: 'Instalación solar certificada',
    validTill: 'Válido hasta: %{date}',
    noDataAvailable: 'Sin datos disponibles',
    notAvailable: 'No disponible',
    notApplicable: 'No aplicable',
    title: 'Panel de EIN',
    congratulationSignUp:
      '¡Enhorabuena! Ahora tendrá acceso anticipado a todos los productos/servicios nuevos de Enphase',
    benefits: 'Beneficios',
    installationShareTooltip:
      'Este número indica qué porcentaje de sus instalaciones totales ha sido instalaciones de Enphase',
    dataFromThirdParty: '*Según datos de una fuente de terceros',
    reviewsNotAvailable: 'No hay revisiones disponibles',
    enphaseExecutive: 'Ejecutivo de Enphase',
    digitalAssets: 'Activos digitales',
    leads: 'Clientes potenciales',
    tierSavings: 'Ahorros por nivel',
    exclusiveUpdates: 'Actualizaciones exclusivas',
    executiveSponsor: 'Patrocinador ejecutivo',
    merchandise: 'Mercancía',
    certifiedUsers: 'Usuarios certificados',
    noteAllowedOnce: 'Nota: El enlace anterior no puede ser editado una vez creado',
    saveLink: `Guardar enlace`,
    confirm: `CONFIRMAR`,
    copyLink: 'Copiar enlace',
    allowedCharactersError: 'Solo se permiten letras, números, guiones y guiones bajos (máx. de 500 caracteres)',
    createSystemEstimatorLink: `Cree su enlace personalizado para la Calculadora del sistema y compártalo con sus clientes para obtener clientes potenciales a través de ellos. Cualquier cliente potencial generado a partir de este enlace se compartirá solo con usted en su gestor de enlighten.`,
    shareSystemEstimatorLink: `Comparta su vínculo personalizado de la Calculadora de sistema con sus clientes para obtener clientes potenciales a través de ellos. Cualquier cliente potencial generado a partir de este enlace se compartirá solo con usted en su gestor de enlighten.`,
    systemEstimatorLink: 'Enlace de Calculadora del sistema',
    confirmChanges: 'Confirmar cambios',
    confirmSELink: 'Confirme el enlace de la Calculadora del sistema. Este enlace no se podrá editar una vez guardado.',
    copied: `Copiado`,
    mySELink: 'Vínculo de Mi Calculadora del sistema',
    sdtUrlExistsError: 'This link is already in use by another installer. Please choose a different link',
    all: 'Todo',
    filterText: 'Filtrar',
    noProductAvailable: 'No hay productos disponibles'
  }
};

export default einDashboard;
